import {KeyboardTimePicker} from "@material-ui/pickers";
import {Grid, withStyles} from "@material-ui/core";
import {Field} from "formik";
import * as PropTypes from "prop-types";
import style from "./styles";
import React from "react";
import {TextFieldNumber} from './TextFieldNumber';
import is from 'is_js';
import moment from 'moment';


const InputTimeBuilder = (props) => {
    const {classes, fieldSchema: schema, formProps = {}} = props;
    return <Grid item {...schema.sizes}>
        <Field name={schema.field} {...props}
               validate="false"
               required={schema.isRequired}
               onKeyDown={console.log}
               validateOnMount="true">
            {
                ({field, form}) => {
                    const {onBlur, onChange, value, ...other} = field;
                    function handleBlur(e){
                        form.setFieldValue(other.name, e.target.value.replace(/_:__$/g, '0:00').replace(/__$/g, '00').replace(/_$/g, '0'))
                    }
                    function onKeydown(e) {
                        if(['ArrowUp', 'ArrowDown'].includes(e.key)){
                            e.preventDefault()
                            if(e.target.value.includes('_') || is.empty(e.target.value))
                                return
                            const addSub = e.key === 'ArrowUp' ? 'add' : 'subtract';
                            if(e.ctrlKey) {
                                return form.setFieldValue(other.name, moment(e.target.value, 'HH:mm')[addSub](1, 'hour').format('HH:mm'))
                            }
                            return form.setFieldValue(other.name, moment(e.target.value, 'HH:mm')[addSub](1, 'minute').format('HH:mm'))
                        }
                    }
                    return <KeyboardTimePicker
                        {...field}
                        clearable
                        className={classes.margin}
                        format={schema.format}
                        label={schema.label}
                        autoFocus={formProps.autoFocus && schema.autoFocus}
                        disabled={schema.disabled}
                        inputValue={value}
                        emptyLabel={''}
                        invalidDateMessage={'Horário Inválido'}
                        autoOk
                        autoComplete={'off'}
                        TextFieldComponent={TextFieldNumber}
                        ampm={false}
                        onKeyDown={onKeydown}
                        onBlur={handleBlur}
                        onChange={(value, valueString) => form.setFieldValue(other.name, valueString)}
                        KeyboardButtonProps={{
                            'aria-label': 'change time',
                            tabIndex: -1,
                            size: 'small'
                        }}
                    />
                }
            }
        </Field>
    </Grid>;
};


InputTimeBuilder.propTypes = {
    classes: PropTypes.any,
    data: PropTypes.any
};

export default withStyles(style)(InputTimeBuilder);
